let newsInfo = {
  result: 0,
  desc: "successful",
  content: {
    article: [
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-17 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-18 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-18 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-18 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-18 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
      {
        name: "赛诺贝斯全资子公司赛诺赛诺赛诺赛诺数赛诺数赛诺数数赛诺数数赛诺数数",
        createTime: "2019-09-18 12:00:00",
        desc: "全方面解读股权激励全方面解读股权激励全方面励全方面解读股权激励全方面权激励全方面解读股权激励全方面他全方面权激励全方面解读股权激励全方面他",
        coverImageRealPath: "./images/avatar02.jpg",
      },
    ],
    column: [
      {
        name: "报名资讯",
        article: [],
      },
      {
        name: "演讲资讯",
        article: [],
      },
    ],
  },
};
export default newsInfo;
